import React from 'react';
import { Chip } from '../../wag-react/components/Chip';
export type SymptomValue = string;
type Props = {
  value: SymptomValue;
};
export const Symptom = (props: Props) => <Chip {...props} border="1px solid #3A5080" textProps={{
  color: '#3A5080'
}} data-sentry-element="Chip" data-sentry-component="Symptom" data-sentry-source-file="index.tsx" />;
export type SymptomProps = Props;